import { render, staticRenderFns } from "./sparkle-bold-icon.vue?vue&type=template&id=8809e4ba"
import script from "./sparkle-bold-icon.vue?vue&type=script&lang=js"
export * from "./sparkle-bold-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports